import { render } from "./SzCellRemove.vue?vue&type=template&id=4bb64a9e&scoped=true"
import script from "./SzCellRemove.vue?vue&type=script&lang=ts"
export * from "./SzCellRemove.vue?vue&type=script&lang=ts"

import "./SzCellRemove.vue?vue&type=style&index=0&id=4bb64a9e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4bb64a9e"

export default script